import { Link } from 'react-router-dom';
import { Container, Typography, Paper, Button, Box } from '@mui/material';

const ResetConfirmation = () => {
  return (
    <Container maxWidth="sm">
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Paper elevation={3} style={{ padding: '2rem', textAlign: 'center' }}>
          <Typography variant="h4" component="h2" gutterBottom>
            Password Reset Email Sent
          </Typography>
          <Typography variant="body1" paragraph>
            If an account exists with the provided email and username, you will receive a password reset link shortly.
            Please check your email and follow the instructions to reset your password.
          </Typography>
          <Typography variant="body1" paragraph>
            If you don't receive an email within a few minutes, please check your spam folder.
          </Typography>
          <Button component={Link} to="/" variant="contained" color="primary">
            Return to Login
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default ResetConfirmation;